<template>
<div >
    <!-- <span class="el-icon-edit cp" style="color: #ff0000" @click="aendernClicked"></span>  -->
   <h6 ><q-btn  @click="aendernClicked" size="xs" icon="edit" color="red"/> {{instanceData.titel}}<br><span class="help">{{instanceData.helpText}}</span> </h6>

   
   <!-- <button class="btn-sm btn-success" v-for="thing in instanceData.bucket" v-bind:key="thing.id" @click="removeThing(thing)">{{thing.name}}</button> -->
   
     <div v-show="instanceData.bucket.length==0">Keine ausgewählt</div>
   
     <table class="table table-striped" v-show="instanceData.bucket.length > 0" style="width:500px">
       <tr v-for="thing in instanceData.bucket" v-bind:key="thing.id">
         <td>{{ thing.name }}</td>
         <td style="text-align:right">
           <!-- 
             <button icon="el-icon-delete" class="btn btn-danger" @click="removeThing(thing)">entfernen</button> -->
         <!-- <i class="el-icon-delete" @click="removeThing(thing)"></i> -->
         <q-btn size="s" icon="delete" @click="removeThing(thing)" />
         </td>
       </tr>
     </table>
   
   
     <q-dialog
      v-model="dialogVisible"
      transition-show="fade"
      transition-hide="fade"
      class="scroll"
      

    >

     <!-- <el-dialog v-model="dialogVisible" :title="instanceData.dialogTitel" width="80%" :before-close="handleClose"> -->

      <q-card class="" style="min-width: 600px;min-height: 600px">
            <q-card-section>
              
              <q-input ref="filter" autofocus v-model="suchString" @keyup="autocomplete" label="Suchbegriff"/>
   
              
   <div >
     <table class="table table-striped table-fit" style="min-width:580px">
       <tr>
         <!-- <th colspan="2">{{instanceData.titel}}</th> -->
       </tr>
       <tr v-bind:key="thing.id" v-for="thing in dataArray" @click="updateVerkaufsregel(thing)">
         <td>
           {{ thing.name }} 
         </td>
         <td>
           <q-btn color="secondary" v-show="getBucketIndex(thing)===-1" label="Hinzufügen" />
           <q-btn color="red" v-show="getBucketIndex(thing)>-1" label="entfernen" />
           
         </td>
        
       </tr>
     </table>
     
     <!-- <ul >
       <li v-bind:key="promoter.id" v-for="promoter in promotoren" @click="updatePromoter(promoter)">{{promoter.name}}</li>
     </ul> -->
   </div>

            </q-card-section>

            

            <!-- <q-card-actions align="right" class="bg-white text-teal">
              <q-btn flat label="OK" @click="updatePW" />
            </q-card-actions> -->
          </q-card>



   
       <template #footer>
         <span class="dialog-footer">
           <q-btn @click="dialogVisible = false" label="Abbrechen" />
           <q-btn type="primary" @click="dialogVisible = false" label="OK" />
         </span>
       </template>
     <!-- </el-dialog> -->
     </q-dialog>
     </div>
   </template>
   <script>
   import { ref, inject,computed } from "vue";
   import { useQuasar } from 'quasar';
   // import helpers from "../services/helpers.js";
   export default {
     props: {
       verkaufsregel: Object,
       typ: String,
       max:Number
     },
     setup(props) {
       console.log("Props", props);
   
   
   
   
       const web = inject("web");
       const $q = useQuasar();
   
       let dialogVisible = ref(false);
       let dataArray = ref([]);
       let suchString = ref("");
       const regeltyp = ref(props.typ)
       const instanceData = getInstanceData()
   
       const options = ref([]);
       // const myPromoter = ref(props.promoter);
   
   
        // let myEinsatz=ref(props.einsatz)
       let myVerkaufsregel = computed(() => {
         return props.verkaufsregel;
       });
   
       let myMax = computed(() => {
         if(typeof(props.max)=="undefined"){
           return 0
         }
         return parseInt(props.max)
       });
   
   
   
       function updateVerkaufsregel(thing) {
         console.log("myMax",myMax.value);
         console.log("instanceData.bucket.length",instanceData.bucket.length);
         console.log(instanceData.bucket);
         
   
        //  let index=instanceData.bucket.indexOf(thing)
        //  if(index==-1){
            let index=getBucketIndex(thing);
         if(index===-1){

          if(myMax.value > 0 &&   instanceData.bucket.length >= myMax.value){
           $q.notify("Maximum von "+myMax.value+" erreicht")
           return;
         }

           instanceData.bucket.push(thing)
         }else{
           instanceData.bucket.splice(index,1)
   
         }
         
         // emit("update:promoter", myPromoter.value);
   
       }
   
   
   
       let timeout = null;
       function autocomplete() {
         let query = suchString.value;
   
         if (query == "") {
           options.value = [];
         }
         if (timeout !== null) {
           clearTimeout(timeout);
         }
         timeout = setTimeout(() => {
             web.post_cb(instanceData.url, { id_promotion:props.verkaufsregel.id_promotion,searchText: query },function(data){

              dataArray.value=data
            });
         }, 250);
       }
   
       function aendernClicked() {
         console.log('aendernClicked',aendernClicked)
         dialogVisible.value = true;
       }
   
       function handleClose() {
         console.log("close");
         dialogVisible.value = false;
       }
   
       function getInstanceData(){
         switch(regeltyp.value){
           case "promoter":
             return {
                 titel:"Promotoren",
                 dialogTitel:"Promotoren auswählen",
                 url:"/promoterAutocomplete",
                 bucket:props.verkaufsregel.promoter
             }
           case "location":
             return {
                 titel:"Locations",
                 dialogTitel:"Locations auswählen",
                 url:"/locationAutocomplete",
                 bucket:props.verkaufsregel.locations
             }
           case "produktausgaben":
             return {
                 titel:"Produkt Ausgabe pro Produkt",
                 helpText:"Dieses Produkt wird in einer Sonderzahlung ausgegeben, wenn die Kriterien passen.",
                 dialogTitel:"Produkt auswählen",
                 url:"/produktAutocomplete",
                 bucket:props.verkaufsregel.produktausgaben
             }
           case "produkt":
             return {
                 titel:"Produkte",
                 dialogTitel:"Produkt auswählen",
                 url:"/produktAutocomplete",
                 bucket:props.verkaufsregel.produkte
             }
           case "dasprodukt":
             return {
                 titel:"Das Produkt",
                 dialogTitel:"Das Produkt auswählen",
                 url:"/produktAutocomplete",
                 bucket:props.verkaufsregel.dasprodukt
             }
   
           case "jobnummer":
             return {
                 titel:"Jobnummern",
                 dialogTitel:"Jobnummer auswählen",
                 url:"/jobnummerAutocomplete",
                 bucket:props.verkaufsregel.jobnummern
             }
   
   
   
         }
   
         
       }
   
       function removeThing(thing){
         if(!confirm("Sicher?")) return;
         
         for (let i = 0; i < instanceData.bucket.length; i++) {
           
           const element = instanceData.bucket[i];
           console.log('element',element)
           if(element.id==thing.id){
             instanceData.bucket.splice(i,1);
             return;
           }
           
         }
   
       }


       function getBucketIndex(thing){
        //  console.log('thing',thing)
        
        // console.log('instanceData.bucket',instanceData.bucket.length)

        for (let i = 0; i < instanceData.bucket.length; i++) {
           
           const element = instanceData.bucket[i];
           console.log('element',element)
           console.log('thing',thing)
           if(element.id==thing.id){
             
             return i;
           }
           
         }

         return -1

       }
   
       return {
        getBucketIndex,
         removeThing,
         handleClose,
         dialogVisible,
         myVerkaufsregel,
         aendernClicked,
         suchString,
         autocomplete,
         dataArray,
         regeltyp,
         instanceData,
         updateVerkaufsregel
         
       };
     },
     
   };
   </script>
   
   <style scoped>
   /* ul{
     margin:0px;
     padding:20px;
     cursor:pointer;
   } */
   
   .btn-sm{
     margin-left:5px;
     }
   
     .table-striped > tr:nth-child(odd) {
  background-color: #f2f2f2;
}


table{
  border-spacing: 0px;
 
}
table tr td,table tr th{
  padding:10px;
}

   td {
     cursor: pointer;
   }
   table.table-fit {
     width: auto !important;
     table-layout: auto !important;
   }
   table.table-fit thead th,
   table.table-fit tfoot th {
     width: auto !important;
   }
   table.table-fit tbody td,
   table.table-fit tfoot td {
     width: auto !important;
   }
  
   </style>
   